import { render } from "./AdminPhieuCongLuong.vue?vue&type=template&id=877733fe"
import script from "./AdminPhieuCongLuong.vue?vue&type=script&lang=js"
export * from "./AdminPhieuCongLuong.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__